import site from '../../site';
import actionTypes from '../constants/action-types';
import getBlock from '../selectors/block';
import setBlockVariationHTML from '../actions/set-block-variation-html';
import errors from '../../errors';
import getBlockVariations from '../selectors/block-variations';
import siteLocales from '../../site-locales';
import initializeBlock from '../actions/initialize-block';
import getBlocks from '../selectors/blocks';
import normalizeLocalizedSource from '../../site-locales/helpers/normalize-localized-source';

const blockFetcher = (store) => (next) => (action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE_BLOCK: {
      const state = store.getState();
      const block = getBlock(state, action.payload.blockId);
      const { locale, htmlLocale, callbacks } = action.payload;

      const variations = getBlockVariations(state, block.id);
      const sourceLoadingQue = [];

      variations.reduce((acc, variation) => {
        if (variation.html) {
          return acc;
        }

        const promise = new Promise((resolve, reject) => {
          site.helpers
            .fetchAsset(normalizeLocalizedSource(variation.source, htmlLocale))
            .then((response) => {
              store.dispatch(setBlockVariationHTML(block.id, variation.id, response.data, locale));
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
        });

        acc.push(promise);

        return acc;
      }, sourceLoadingQue);

      if (!sourceLoadingQue.length) {
        next(action);
        return;
      }

      Promise.all(sourceLoadingQue)
        .then(() => {
          next(action);

          callbacks.resolve(block);
        })
        .catch((error) => {
          callbacks.reject(error);
        });

      break;
    }
    case site.actionTypes.SET_ACTIVE_PAGE: {
      const state = store.getState();
      const { pageId: nextActivePageId } = action.payload;
      const siteBlocks = getBlocks(state);
      const activePageId = site.selectors.getActivePageId(state);
      const activePage = site.selectors.getPage(state, activePageId);
      const activePageHtmlLocale = activePage && activePage.htmlLocale;
      const nextActivePage = site.selectors.getPage(state, nextActivePageId);
      const nextActivePageHtmlLocale = nextActivePage && nextActivePage.htmlLocale;
      const nextActivePageLocale = nextActivePage && nextActivePage.locale;

      // we are using `htmlLocale` to localize blocks, most of the time `locale` and `htmlLocale` would be same,
      // but this covers edge case for older users who had changed `htmlLocale` before multilingual site introduction and they have their block localized to that language
      if (nextActivePageHtmlLocale !== activePageHtmlLocale) {
        store.dispatch(siteLocales.actions.clearBlocksHtml());

        const blockLoadingPromises = siteBlocks.map(
          (block) =>
            new Promise((resolve, reject) => {
              store.dispatch(
                initializeBlock(block.id, nextActivePageLocale, nextActivePageHtmlLocale, {
                  resolve,
                  reject,
                })
              );
            })
        );

        Promise.all(blockLoadingPromises).catch((error) => {
          errors.operations.catchError(error);
        });
      }
      next(action);
      break;
    }
    case site.actionTypes.RELOAD_SITE_META: {
      const { site: siteData } = action.payload;
      const state = store.getState();
      const siteBlocks = getBlocks(state);
      const prevActivePageId = site.selectors.getActivePageId(state);
      const prevActivePage = site.selectors.getPage(state, prevActivePageId);
      const prevActivePageHtmlLocale = prevActivePage && prevActivePage.htmlLocale;
      const activePage =
        siteData.meta.pages.find((page) => page.id === siteData.meta.activePage) ||
        siteData.meta.pages[0];
      const activePageHtmlLocale = activePage && activePage.htmlLocale;
      const activePageLocale = activePage && activePage.locale;

      if (siteBlocks && prevActivePageHtmlLocale !== activePageHtmlLocale) {
        store.dispatch(siteLocales.actions.clearBlocksHtml());

        const blockLoadingPromises = siteBlocks.map(
          (block) =>
            new Promise((resolve, reject) => {
              store.dispatch(
                initializeBlock(block.id, activePageLocale, activePageHtmlLocale, {
                  resolve,
                  reject,
                })
              );
            })
        );

        Promise.all(blockLoadingPromises).catch((error) => {
          errors.operations.catchError(error);
        });
      }

      next(action);
      break;
    }
    default:
      next(action);
  }
};

export default blockFetcher;
